import * as THREE from 'https://unpkg.com/three@0.183.0/build/three.module.js';

const instances = new Map();

function initCharacter(root) {
  const character = root.querySelector('.webgl-hero__character');
  if (!character) return;

  const width = parseInt(root.dataset.characterWidth || '320', 10);
  const bottom = parseInt(root.dataset.characterBottom || '20', 10);
  const duration = parseInt(root.dataset.walkDuration || '5', 10);

  character.style.width = `${width}px`;
  character.style.bottom = `${bottom}px`;
  character.style.animationDuration = `${duration}s, 0.45s, 0.9s`;

  requestAnimationFrame(() => {
    character.classList.remove('is-animating');
    void character.offsetWidth;
    character.classList.add('is-animating');
  });
}

function initWebGLSection(root) {
  if (!root || instances.has(root)) return;

  const canvas = root.querySelector('.webgl-hero__canvas');
  if (!canvas) return;

  const bg = root.dataset.bg || '#111111';
  const speed = parseFloat(root.dataset.speed || '2') / 100;
  const height = parseInt(root.dataset.height || '700', 10);

  root.style.minHeight = `${height}px`;

  const scene = new THREE.Scene();
  scene.background = new THREE.Color(bg);

  const camera = new THREE.PerspectiveCamera(60, 1, 0.1, 100);
  camera.position.z = 3;

  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: false
  });

  const geometry = new THREE.TorusKnotGeometry(0.7, 0.25, 128, 32);
  const material = new THREE.MeshNormalMaterial();
  const mesh = new THREE.Mesh(geometry, material);
  scene.add(mesh);

  const light = new THREE.DirectionalLight(0xffffff, 2);
  light.position.set(2, 2, 3);
  scene.add(light);

  let frameId;

  function resize() {
    const width = root.clientWidth;
    const currentHeight = root.clientHeight || height;

    camera.aspect = width / currentHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(width, currentHeight, false);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  }

  function animate() {
    mesh.rotation.x += speed * 0.7;
    mesh.rotation.y += speed;

    renderer.render(scene, camera);
    frameId = requestAnimationFrame(animate);
  }

  const ro = new ResizeObserver(() => {
    resize();
  });

  ro.observe(root);

  resize();
  animate();
  initCharacter(root);

  instances.set(root, {
    destroy() {
      cancelAnimationFrame(frameId);
      ro.disconnect();
      geometry.dispose();
      material.dispose();
      renderer.dispose();
      instances.delete(root);
    }
  });
}

function destroyWebGLSection(root) {
  const instance = instances.get(root);
  if (instance) instance.destroy();
}

function initAll() {
  document.querySelectorAll('.webgl-hero').forEach(initWebGLSection);
}

document.addEventListener('DOMContentLoaded', initAll);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.webgl-hero') || event.target;
    initWebGLSection(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('.webgl-hero') || event.target;
    destroyWebGLSection(root);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const root = event.target.querySelector('.webgl-hero') || event.target;
    initCharacter(root);
  });
}